const message = Object.freeze({
  HELP_TEXT: `* Este campo representa la posición del marcador según la geolocalización. No afecta el domicilio como se muestra en cartilla. 
  Podés arrastrar el marcador hasta la posición deseada o hacer doble click en el mapa.`,
  SNB_ADDRESS_NOT_SET: 'El registro seleccionado no tiene configurado domicilio aún.',
});

export default message;